// 获得系统版本（PC-0，iOS-1，Android-2）
export const getSystem = () => {
  let system = "Other";
  /*
   * ipad环境判断更新
   * iOS pre 13 以前以ua作判断，13后以platform及maxTouchPoints做判断
   */
  var isiPad =
    navigator.userAgent.match(/(iPad)/) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  if (/(iPhone|iPad|iPod|iOS)/i.test(window.navigator.userAgent) || isiPad) {
    system = "iOS";
  } else if (/(Android)/i.test(window.navigator.userAgent)) {
    system = "android";
  } else {
    system = "PC";
  }

  return system;
};
// 手机格式校验
export const PhoneCheck = (phone, areacode) => {
  const validateFormat = (pattern) => {
    return phone.match(pattern);
  };

  switch (areacode) {
    case "886": // 臺灣 09 開頭 10位數字
      var patt1 = /^(\+886\s)?[0]{0,1}[9]{1}\d{8}$/;
      break;
    case "852": // 香港 5、6、9 開頭 8位數字
      var patt2 = /^(\+852\s)?[569]{1}\d{7}$/;
      break;
    case "853": // 澳門 6 開頭 8位數字
      var patt3 = /^(\+853\s)?[6]\d{7}$/;
      break;
    default:
      // 格式錯誤
      return false;
  }

  const isValidFormat = validateFormat(patt1 || patt2 || patt3);

  if (isValidFormat) {
    // 格式正確
    return true;
  } else {
    // 格式錯誤
    return false;
  }
};

import { xhSet, xhGet } from "./xhCookie";
// 判断是否首次进入页面
// 0为假 1为真
export const firstPage = () => {
  if (!xhGet("XH-WEB")?.isRefresh) {
    // 首次进入
    xhSet("XH-WEB", { isRefresh: 1 });
    return true;
  } else if (xhGet("XH-WEB")?.isRefresh == 1) {
    // 刷新页面，非首次进入
    xhSet("XH-WEB", { isRefresh: 0 });
    return false;
  }
};

import qs from "qs";
// 解析URL參數
export const parseUrl = (link) => {
  return qs.parse(link.split("?")[1]);
};

export const os = () => {
  var isiPad =
    navigator.userAgent.match(/(iPad)/) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  if (/(iPhone|iPad|iPod|iOS)/i.test(window.navigator.userAgent) || isiPad) {
    // This is iOS
    return 2;
  } else if (/Android/i.test(navigator.userAgent)) {
    // This is Android
    return 1;
  } else {
    // This is neither iOS nor Android
    return 3;
  }
};
// 判断前端类型
export const client = () => {
  if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    // wap
    return "2";
  } else {
    // pc
    return "1";
  }
};

export const deviceType = () => {
  if (os() == 3) {
    return "pc";
  } else {
    return "wap";
  }
};

export const Storage = {
  set: (key, data) => {
    localStorage.setItem(key, JSON.stringify(data));
  },
  get: (key) => {
    return JSON.parse(localStorage.getItem(key));
  },
};

// 删除接口错误提示括号内容数字
export const removeBracketContent = (str) => {
  return str.replace(/\[.*?\]/g, "");
};

export const bottomScroll = () => {
  var windowHeight = window.innerHeight;
  var body = document.body;
  var html = document.documentElement;
  var documentHeight = Math.max(
    body.scrollHeight,
    body.offsetHeight,
    html.clientHeight,
    html.scrollHeight,
    html.offsetHeight
  );
  var scrollableDistance = documentHeight - windowHeight;
  var scrolledDistance =
    window.pageYOffset ||
    (document.documentElement || document.body.parentNode || document.body)
      .scrollTop;

  if (scrollableDistance - scrolledDistance <= 1) {
    return true;
  }
};

import useClipboard from "vue-clipboard3";
const { toClipboard } = useClipboard();
// 复制文本
export const copy = async (val, hint) => {
  console.log(hint);
  // console.log(type, val)
  // if (type == 'code' && !val) {
  //     return ElMessage({
  //         message: "暫未滿足領取條件",
  //         center: true,
  //         offset: 200,
  //         type: "error",
  //         customClass: 'ElMessageIndex'
  //     });
  // }
  try {
    await toClipboard(val ? val : hint);
    return ElMessage({
      message: hint ? hint : "複製成功",
      center: true,
      offset: 200,
      type: "success",
      customClass: "ElMessageIndex",
    });
  } catch (e) {
    return ElMessage({
      message: "複製失敗，請嘗試手動複製",
      center: true,
      offset: 200,
      type: "error",
      customClass: "ElMessageIndex",
    });
  }
};

// 敬请期待
import { ElMessage } from "element-plus";
export const Expect = (link, text) => {
  if (link) {
    window.open(link, "_blank");
  } else {
    ElMessage({
      message: text,
      center: true,
      offset: 200,
      type: "success",
    });
  }
};

export const scrollToSpecificHeight = (topValue) => {
  window.scrollTo({
    top: topValue,
    behavior: "smooth",
  });
};

// 去除对象中字符串值的前后空格
export const trimParams = (params) => {
  if (typeof params === "string") {
    return params.trim();
  } else if (Array.isArray(params)) {
    return params.map((item) => trimParams(item));
  } else if (typeof params === "object" && params !== null) {
    return Object.keys(params).reduce((acc, key) => {
      acc[key] = trimParams(params[key]);
      return acc;
    }, {});
  }
  return params;
};

export const geteQuipment = (val) => {
  let type;
  if (val == 0) {
    if (deviceType() == "pc") {
      type = "1";
    } else {
      type = "2";
    }
  }
  if (val == 1) {
    if (getSystem() == "android") type = "1";
    if (getSystem() == "iOS") type = "2";
    if (getSystem() == "PC") type = "3";
  }
  return type;
};

// 浏览器语言 默认英语
export const lang = () => {
  const primaryLanguage = (
    navigator.language ||
    navigator.browserLanguage ||
    navigator.userLanguage
  ).toLowerCase();
  if (primaryLanguage.startsWith("zh")) {
    return "cn";
  } else if (primaryLanguage.startsWith("th")) {
    return "th";
  } else {
    return "en";
  }
};
